import { intl } from "@fidget/common/i18n";
import { IChatInput } from "src/models/room/ChatInput";

export function validateIntentResponse(input?: IChatInput) {
  return input?.isReadyToSend
    ? ""
    : intl.formatMessage("ai.modelConfiguration.intent.form.response.errorEmpty");
}
